import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { IdapService } from '~core/services';

@Component({
  selector: 'idap-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  copyRightText: Observable<string>;

  constructor(private idapService: IdapService) {
    this.copyRightText = this.idapService.getCopyrightText();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/footer.component.ts